import ABSUtils from '@abs/utils';
import AppContext from 'app/AppContext';
import { authModules } from 'app/auth';
import { Component } from 'react';
import { matchRoutes } from 'react-router-dom';
import withRouter from '@abs/core/withRouter';
import history from '@history';

let loginRedirectUrl = null;

class ABSAuthorization extends Component {
  constructor(props, context) {
    super(props);
    const { routes } = context;
    this.state = {
      accessGranted: true,
      redirectUrl: null,
      routes,
    };
    this.defaultLoginRedirectUrl = props.loginRedirectUrl || '/';
  }

  componentDidMount() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.accessGranted !== this.state.accessGranted;
  }

  componentDidUpdate() {
    if (!this.state.accessGranted) {
      this.redirectRoute();
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { location, userModules } = props;
    const { pathname } = location;

    const matchedRoutes = matchRoutes(state.routes, pathname);

    const matched = matchedRoutes ? matchedRoutes[0] : false;

    var accessgrant = matched ? ABSUtils.hasModulePermission(matched.route.auth, userModules) : true;
    var redir = !accessgrant ? (matched.route.auth == authModules.notloggedin ? "/" : null) : null;
    return {
      accessGranted: accessgrant,
      redirectUrl: redir
    };
  }

  //only gets called if no permission or redirect after an action
  redirectRoute() {
    const { location, userModules } = this.props;
    const { pathname } = location;

    //check if already a redirect url is defined, else check if not logged in, then check if only has abs module else show error
    let redirectUrl = loginRedirectUrl ? loginRedirectUrl : (this.state.redirectUrl ? this.state.redirectUrl : (ABSUtils.hasModulePermission(authModules.loggedin, userModules) ? '/error403' : '/error404'));

    //if redirecting to mainpage, pick the first available licence in priority order (tl, eo, pm, bb, iv) or fall back to usersettings (prevents infinite redirect loop)
    if (redirectUrl == '/') {
      if (userModules.includes('tl_default')) redirectUrl = '/tl';
      else if (userModules.includes('eo_default')) redirectUrl = '/eo';
      else if (userModules.includes('pm_default')) redirectUrl = '/pm';
      else if (userModules.includes('bb_default')) redirectUrl = '/bb';
      else if (userModules.includes('iv_default')) redirectUrl = '/iv';
      else redirectUrl = '/usersettings';
    }

    /*
        Not logged in
        Redirect to Login Page
        */
    if (!userModules || userModules.length === 0) {
      setTimeout(() => history.push('/login'), 0);
      if (pathname != '/logout')
        loginRedirectUrl = pathname;
    }
    /*
      User is at least logged in
      User must be on unAuthorized page or just logged in
      Redirect to redirectUrl or errorpage
    */
    else {
      setTimeout(() => history.push(redirectUrl), 0);
      loginRedirectUrl = this.defaultLoginRedirectUrl;
    }
  }

  render() {
    // console.info('ABS Authorization rendered', this.state.accessGranted);
    return this.state.accessGranted ? <>{this.props.children}</> : null;
  }
}

ABSAuthorization.contextType = AppContext;

export default withRouter(ABSAuthorization);
